import { useAuth } from '../../auth/useAuth';

export default function ProfilePage(): JSX.Element {
  const { user } = useAuth();
  return (
    <div className="page-placeholder" style={{ textAlign: 'left' }}>
      <h1>프로필</h1>
      <p>이름: {user?.name ?? '-'}</p>
      <p>이메일: {user?.email ?? '-'}</p>
      <p>ID: {user?.id ?? '-'}</p>
      <hr />
      <p>이름 변경·아바타·비밀번호 변경은 후속 구현입니다.</p>
    </div>
  );
}
